module.exports = __webpack_public_path__ + "static/img/icon_cardtype_list.c1a4d03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_cardtype_list.svg
// module id = 5kV9
// module chunks = 10